import React from 'react';
import { type IFacetContextShape } from '../../types/facetTypes';

export const FacetContext = React.createContext<IFacetContextShape | null>(null);

export default FacetContext;
